<!--表单页面拷贝开始-->
<template>
  <div>
    <form-components @submitForm="submitForm">
      <template v-slot:content>
        <el-form-item label="连接名称">
          <el-col :span="8">
            <el-input v-model="connectorBasic.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="主域名">
          <el-col :span="8">
            <el-input v-model="connectorBasic.domain"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="URL地址">
          <el-col :span="8">
            <el-input v-model="connectorBasic.url"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="请求方式">
          <el-col :span="8">
            <el-input v-model="connectorBasic.method"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="描述信息">
          <el-col :span="8">
            <el-input v-model="connectorBasic.remark"></el-input>
          </el-col>
        </el-form-item>
      </template>
    </form-components>
  </div>
</template>
  
  <script>
import FormComponents from "@/components/form/FormComponents";
import ConnectorBasicApi from "@/api/ConnectorBasicApi";
import { navTo, queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "SaveConnectorBasicPage",
  props: {
    msg: String,
  },
  components: {
    FormComponents,
  },
  data() {
    return {
      connectorBasic: {
        name:"",
        url: "",
        method: "",
        domain: "",
        remark: "",
        categoryId:0
      },
    };
  },
  created() {
    this.connectorBasic = this.$route.params;
    let id = this.$route.query.categoryId;
    if(id){
      this.connectorBasic.categoryId =id;
    }
    },
  methods: {
    submitForm() {
      this.connectorBasic.id > 0
        ? this.updateConnectorBasicById()
        : this.addConnectorBasic();
    },
    addConnectorBasic() {
      ConnectorBasicApi.saveConnectorBasic(this.connectorBasic).then((resp) => {
        if (resp.state == "OK") {
          this.connectorBasic = {};
          this.$successMsg(resp.msg);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    updateConnectorBasicById() {
      ConnectorBasicApi.updateConnectorBasic(this.connectorBasic).then(
        (resp) => {
          if (resp.state == "OK") {
            this.$successMsg(resp.msg);
            navTo(this, "/connectorBasicList?categoryId="+this.connectorBasic.categoryId);
          } else {
            this.$errorMsg(resp.msg);
          }
        }
      );
    },
  },
};
</script>
  
  
  <!--表单页面拷贝结束-->